import styled from 'styled-components';

export const RowBetween = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 0.5rem;
  color: ${({ theme, color }) => (color ? color : theme.text[700])};
`;
